import React, { useRef } from "react";
import emailjs from '@emailjs/browser'; 
import '../css/form.css';

function Contactform(){
    const form = useRef();

    const validateEmail = async (email) => {
      const apiKey = '4f4c3bc3505648d587ab5a4c359a9b9d';
      const apiUrl = `https://emailvalidation.abstractapi.com/v1/?api_key=${apiKey}&email=${encodeURIComponent(email)}`;
  
      try {
        const response = await fetch(apiUrl);
        const result = await response.json();
  
        // Verificar si el correo electrónico es válido
        if (
          result.is_valid_format &&
          result.is_mx_found &&
          result.is_smtp_valid &&
          result.deliverability === 'DELIVERABLE'
        ) {
          return true;
        } else {
          alert('Please enter a valid email address.');
          return false;
        }
      } catch (error) {
        console.error('Error validating email:', error);
        return false;
      }
    };
  
    const sendEmail = async (e) => {
      e.preventDefault();
  
      // Validar el correo electrónico
      const userEmail = form.current.user_email.value.trim();
      const isEmailValid = await validateEmail(userEmail);
  
      if (!isEmailValid) {
        return;
      }
  
      emailjs
        .sendForm('service_cznbpin', 'template_7t0exz7', form.current, 'IeauC6y6VpYS6v8M5')
        .then((result) => {
          alert(result.text);
          window.location.reload();
        })
        .catch((error) => {
          alert(error.text);
        });
    };
    return (
        <form className="contact-container" id="formContact" ref={form} onSubmit={sendEmail}>
            <div className="image-container">
                <img src={require('../img/formImg.jpg')} alt="Descripción de la imagen" />
            </div>
            <div className="form-container">
                <div className="styled-input">
                    <input type="text" name="user_name" placeholder="Name" required />
                    <label>Name</label>
                </div>
                <div className="styled-input">
                    <input type="email" name="user_email" placeholder="Email" required />
                    <label>Email</label>
                </div>
                <div className="styled-input">
                    <input type="tel" name="user_number" placeholder="Number" required />
                    <label>Phone Number</label>
                </div>
                <div className="styled-input wide">
                    <textarea placeholder="Message" name="message" required></textarea>
                    <label>Message</label>
                </div>
                <button type="submit" className="btn-lrg submit-btn">Send Message</button>
            </div>
        </form>
    );
}

export default Contactform;